import { ArticleHeader } from 'ui/components';
import { useShouldShowContent } from 'helpers/audiencehelper';

export const ArticleHeaderFeature: React.FC<Umbraco.ArticleHeader> = ({ content }) => {
	const show = useShouldShowContent(content.properties.audiencePicker);
	return show ? <ArticleHeader {...content?.properties} className="" /> : <></>;
};
